import { useParams } from "react-router-dom";
import RegionSidebar from "../components/RegionSidebar.jsx";
import RegionPanel from "../components/RegionPanel.jsx";
import { useAzureConfig } from '../../../../../context/Dashboard/azure/contextConfig.js';

export default function RegionViewAws() {
  const service_name = useParams().service;
  const { cAzureConfigAll : data } = useAzureConfig();
  const regionData = data.services[service_name].regions;

  return (
    <div className="region-layout">
      <RegionSidebar regions={regionData} />
      <RegionPanel regions={regionData} service_name={service_name} />
    </div>
  );
}
